import api, { armorAPI } from '~/services/api';

export function fetchFeatureTests() {
  return api.request({
    url: '/ui/features',
    method: 'GET',
  });
}

export function rollDice(featureTestName) {
  return api.request({
    url: 'ui/features/roll_dice',
    method: 'POST',
    data: {
      feature_test_name: featureTestName,
    },
  });
}

export function assignTestVariant(featureTestName, variantName) {
  return armorAPI.request({
    url: '/feature_tests/reassign/',
    method: 'POST',
    data: {
      test_name: featureTestName,
      variant_name: variantName,
    },
  });
}
